import { Stack, SxProps, Theme } from '@mui/material'
import { FlatRackIcon, useMinimalsTheme } from '@tom-ui/ui'
import { ConfigAreaDto, ConfigAreaType } from '@yard/app/api'
import { getConfigAreaByType } from '@yard/utils'

interface Props {
  configAreas?: ConfigAreaDto[]
  minBay?: number
  maxBay?: number
  minRow?: number
  maxRow?: number
  maxStackHeight?: number
  sx?: SxProps<Theme>
}
export const MaxStackHeight = ({
  configAreas,
  minBay,
  maxBay,
  minRow,
  maxRow,
  maxStackHeight,
  sx,
}: Props) => {
  const theme = useMinimalsTheme()

  let value: number | undefined | null = undefined

  if (maxStackHeight) {
    value = maxStackHeight
  } else if (configAreas && minBay && maxBay && minRow && maxRow) {
    const maxStackHeightConfig = getConfigAreaByType(
      ConfigAreaType.MaxStackHeight,
      configAreas,
      minBay,
      maxBay,
      minRow,
      maxRow,
    )
    value = maxStackHeightConfig?.stackHeight
  }

  if (!value) return null

  return (
    <Stack
      sx={{ scale: '0.8', ...sx }}
      direction='row'
      alignItems='center'
      gap={theme.customSpacing.xxxs}
    >
      <FlatRackIcon fontSize='small' />
      {value}
    </Stack>
  )
}
